export enum Units {
    Metric,
    Imperial,
}

export enum ColorBlindMode {
    Off,
    // TODO: Add color blind mode(s)
}

export interface ISettings {
    units: Units;
    colorBlindMode: ColorBlindMode;
    shortcutsEnabled: boolean;
}